import React, { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';
import { FilterCardProps } from 'common/contracts';

import Button from 'components/Button/Button';
import Input from 'components/Input/Input';

import FilterControl from './FilterControl';

const FilterSearchCard: React.FC<FilterCardProps> = ({
  header,
  filterValue,
  setFilterValue,
  isLabelSearchBy = false
}) => {
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    setSearchValue(filterValue || '');
  }, [filterValue]);

  const handleApply = () => {
    setFilterValue(searchValue);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const handleClear = () => {
    setFilterValue('');
    setSearchValue('');
  };

  return (
    <FilterControl
      header={header}
      filterValue={filterValue}
      displayValue={filterValue}
      onClear={handleClear}
      isLabelSearchBy={isLabelSearchBy}
    >
      {(close) => (
        <div className="p-3">
          <div className="text-sm font-semibold text-gray-600 mb-2">
            Filter By {header}
          </div>
          <Input
            type="text"
            placeholder="Search"
            value={searchValue}
            onChange={handleSearchChange}
            className="w-full"
            rightIcon={
              <FontAwesomeIcon icon="fa-regular fa-magnifying-glass" />
            }
            rightIconStyles="absolute"
          />
          <Button
            className="mt-2 w-full"
            onClick={() => {
              handleApply();
              close();
            }}
          >
            Apply
          </Button>
        </div>
      )}
    </FilterControl>
  );
};

export default FilterSearchCard;
